import * as z from 'zod';

export const manufacturerQueryLinkerSchema = z.object({
  id: z.number(),
  name: z.string(),
  manufacturer_number: z.string().nullable(),
});

export type ManufacturerQueryLinkerSchema = z.infer<typeof manufacturerQueryLinkerSchema>;
